// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchCompleteSignIn,
    NavigateToReturnUrl,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@tps/App/GoogleAnalyticsConnector/Utilities/DataLayer";

const _GaDispatchCompleteSignIn: typeof NavigateToReturnUrl = async props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.loginEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const session = getSession(state);

        // handle issue of redirect before getting billTo companyName
        if (session.billToId) {
            await makeHandlerChainAwaitable(loadBillTo)({
                billToId: session.billToId,
            })(props.dispatch, props.getState);
        }

        const billToInfo = getBillToState(props.getState(), session.billToId)?.value;

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.loginEventName,
            user: session.userProfileId || "",
            company_name: billToInfo?.companyName || "",
            customer_id: session?.billToId,
            customer_number: billToInfo?.customerNumber,
        };
        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, _GaDispatchCompleteSignIn);
